import React from 'react';
import styles from './BusinessListTooltip.module.css';
import PropTypes from 'prop-types';
import { CloseIcon } from '../../../assets';
import {
  useNavigate
} from 'react-router-dom';
import { useTealium } from '../../../tealium/useTealium';

export const BusinessListTooltip = ({ closeTooltipChange, label, isVisible, heading ,subHeading, link, navigatePath}) => {
  const navigate = useNavigate();
  const { track, events } = useTealium();

  if (!isVisible) {return null;}

  const handleNavigate = (link) => {
    track(events.businessList.changeOption(link));
    navigate(navigatePath);
  };

  return (
    <div className={ styles.tooltip}>
      <div className={styles.tooltipHeader}>
        <span>{heading}</span>
        <span>
          <img
            src={CloseIcon}
            className={styles.crossIcon}
            alt="Close Icon"
            role='presentation'
            onClick={closeTooltipChange(label)}
          />
        </span>
      </div>
      <div className={styles.tooltipText}>
        <span >{subHeading}</span>
        <span className={styles.linkStyle} onClick={()=> handleNavigate(link)} >{link}</span>
      </div>
    </div>
  );
};

BusinessListTooltip.propTypes = {
  isVisible: PropTypes.bool,
  heading: PropTypes.string,
  subHeading: PropTypes.string,
  link: PropTypes.string,
  navigatePath: PropTypes.string,
  label: PropTypes.string,
  closeTooltipChange: PropTypes.func
};